// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "734788b466647c491247df46709706ff7b68ff79/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};